/**
 * Core
 */

import { adminRoutes } from '@core/router/routeNames';

/**
 * Middleware
 */

import { allowedRoutesByDefault } from '@core/middleware/globalRoutesByRole';

const allowedAdminRoutes = [
  ...Object.values(adminRoutes),
  ...allowedRoutesByDefault,
];

const userAdminRoutes = [
  adminRoutes.ADMIN,
  adminRoutes.ADMIN_USER,
  adminRoutes.ADMIN_USER_EDIT,
  adminRoutes.ADMIN_USER_CREATE,
  adminRoutes.ADMIN_USERS,
  adminRoutes.ADMIN_INTERNAL_SIGNER_EDIT,
  adminRoutes.ADMIN_INTERNAL_SIGNER_CREATE,
  adminRoutes.ADMIN_INTERNAL_SIGNERS,

  adminRoutes.ADMIN_CRM_USERS,
  adminRoutes.ADMIN_CRM_USER_CREATE,
  adminRoutes.ADMIN_CRM_USER_EDIT,

  ...allowedRoutesByDefault,
];

const contactAdminRoutes = [
  adminRoutes.ADMIN,
  adminRoutes.ADMIN_CONTACT,
  adminRoutes.ADMIN_CONTACT_EDIT,
  adminRoutes.ADMIN_CONTACT_CREATE,
  adminRoutes.ADMIN_CONTACTS,

  ...allowedRoutesByDefault,
];

const ticketAdminRoutes = [
  adminRoutes.ADMIN,
  adminRoutes.ADMIN_WORKFLOW_EDIT,
  adminRoutes.ADMIN_WORKFLOW_CREATE,
  adminRoutes.ADMIN_WORKFLOWS,
  adminRoutes.ADMIN_OPERATION_EDIT,
  adminRoutes.ADMIN_OPERATION_CREATE,
  adminRoutes.ADMIN_OPERATIONS,
  adminRoutes.ADMIN_PACKAGE,
  adminRoutes.ADMIN_ACTUAL_PACKAGE_EDIT,
  adminRoutes.ADMIN_PLANNED_PACKAGE_EDIT,
  adminRoutes.ADMIN_PACKAGE_CREATE,
  adminRoutes.ADMIN_PACKAGES,
  adminRoutes.ADMIN_IDENTITY,
  adminRoutes.ADMIN_CONTRACT_TEMPLATES,
  adminRoutes.ADMIN_CONTRACT_TEMPLATES_CREATE,
  adminRoutes.ADMIN_ATTACHMENTS_TEMPLATES,
  adminRoutes.ADMIN_ATTACHMENT_TEMPLATE_CREATE,

  adminRoutes.ADMIN_SETTINGS_SIGNATURES,
  adminRoutes.ADMIN_SETTINGS_WATCHDOGS,
  adminRoutes.ADMIN_SETTINGS_PERMISSIONS,

  ...allowedRoutesByDefault,
];

const declarationAdminRoutes = [
  adminRoutes.ADMIN,
  adminRoutes.ADMIN_DECLARATIONS,
  adminRoutes.ADMIN_DECLARATION_CREATE,
  adminRoutes.ADMIN_DECLARATION_EDIT,
  adminRoutes.ADMIN_DECLARATION_EDIT_ATTACHMENTS,
  adminRoutes.ADMIN_DECLARATION_EDIT_THEMES,
  adminRoutes.ADMIN_DECLARATION_EDIT_DEPOSIT,
  adminRoutes.ADMIN_DECLARATION_EDIT_SIMPLE_EVENTS,

  ...allowedRoutesByDefault,
];

const conventionsAdminRoutes = [
  adminRoutes.ADMIN,
  adminRoutes.ADMIN_CONVENTIONS,
  adminRoutes.ADMIN_CONVENTION_CREATE,
  adminRoutes.ADMIN_CONVENTION_EDIT,

  ...allowedRoutesByDefault,
];

export {
  allowedAdminRoutes,
  userAdminRoutes,
  ticketAdminRoutes,
  contactAdminRoutes,
  declarationAdminRoutes,
  conventionsAdminRoutes,
};
